/**
 * Formats a number by adding commas and decimal places.
 *
 * @function
 * @param {number} number - The number to be formatted.
 * @param {number} [digits=0] - The number of decimal places to display.
 * @param {boolean} [absoluteNumber=true] - Determines whether to treat the number as an absolute value.
 * @returns {string} The formatted number.
 */
export const formatNumberToDecimal = (number: number, digits = 0, absoluteNumber = true): string => {
  if (isNaN(Number(number))) return '0';

  let result: number | string = number;

  // Take out negative sign
  if (absoluteNumber) {
    result = Math.abs(result);
  }

  // Return 0 if number is -0
  // This is for very small floats not showing -0 when rounded (e.g. -0.0000020 => -0)
  if (result == 0) {
    return Math.abs(result).toLocaleString(undefined, {
      maximumFractionDigits: digits,
      minimumFractionDigits: digits,
    });
  }

  // Add commas and decimal places
  result = result.toLocaleString(undefined, {
    maximumFractionDigits: digits,
    minimumFractionDigits: digits,
  });

  return String(result);
};
